import script from "./TimerSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerSettings.vue?vue&type=script&setup=true&lang=ts"

import "./TimerSettings.vue?vue&type=style&index=0&id=1db98396&scoped=true&lang=css"
import "./TimerSettings.vue?vue&type=style&index=1&id=1db98396&scoped=true&lang=scss"
import "./TimerSettings.vue?vue&type=style&index=2&id=1db98396&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db98396"]])

export default __exports__